import { LeaderSummary } from "../api/models/leader";
import { MemberSummary } from "../api/models/member";
import { OrgSeason } from "../api/models/orgSeason";

export function flattenOrgSeasonToMembers(orgSeason: OrgSeason) {
    const members: MemberSummary[] = [];

    orgSeason.teams.forEach(team => {
        // Add athletes
        team.athletes.forEach(athlete => {
            members.push({
                id: athlete.id,
                role: 'athlete',
                firstName: athlete.firstName,
                lastName: athlete.lastName,
                jerseyNumber: athlete.jerseyNumber,
                teamId: team.id,
                profileLink: athlete.profileLink,
                classGrade: athlete.classGrade,
            });
        });

        // Add leaders
        team.leaders.forEach(leader => {
            members.push({
                id: leader.id,
                role: 'leader',
                firstName: leader.firstName,
                lastName: leader.lastName,
                teamId: team.id,
                profileLink: leader.profileLink,
                classGrade: undefined,
            });
        });
    });

    return members;
}


//want to order team.leaders by identifer HC, AC and then whatever else
export function orderTeamLeaders(leaders: LeaderSummary[]) {
    const order = ['HC', 'AC', 'AT', 'TP', 'EQ', ''];
    return leaders.sort((a, b) => {
        const aIndex = order.indexOf(a.identifier || '');
        const bIndex = order.indexOf(b.identifier || '');
        return aIndex - bIndex;
    });
}

export interface SortableMember {
    lastName: string,
    firstName: string,
    jerseyNumber?: number | null,
}

export const memberNameSort = (a: SortableMember, b: SortableMember): number => {
    if (a.lastName > b.lastName) {
        return 1;
    } else if (a.lastName < b.lastName) {
        return -1;
    }

    if (a.firstName > b.firstName) {
        return 1;
    } else if (a.firstName < b.firstName) {
        return -1;
    } else {
        return 0;
    }
}

export const memberJerseySort = (a: SortableMember, b: SortableMember): number => {
     const aHasJersey = a.jerseyNumber !== undefined && a.jerseyNumber !== null;
    const bHasJersey = b.jerseyNumber !== undefined && b.jerseyNumber !== null;

    if (aHasJersey && bHasJersey) {
        if (a.jerseyNumber! > b.jerseyNumber!) {
            return 1;
        } else if (a.jerseyNumber! < b.jerseyNumber!) {
            return -1;
        } else {
            return 0;
        }
    } else if (aHasJersey && !bHasJersey) {
        return -1;
    } else if (!aHasJersey && bHasJersey) {
        return 1;
    } else {
        return 1;
    }
};

export interface JerseyNumberItem {
    jerseyNumber: number | null;
    jerseyText: string;
    jerseyNumberPadding: number | null;
}

export function GetJerseyNumberItem(jerseyText: string): JerseyNumberItem {

    const jerseyNumber = parseInt(jerseyText);
    if (isNaN(jerseyNumber)) {
        return {
            jerseyNumber: null,
            jerseyText: jerseyText,
            jerseyNumberPadding: null
        };
    }
    const jerseyNumberPadding = jerseyText.length;

    return {
        jerseyNumber,
        jerseyText,
        jerseyNumberPadding
    };
}

export function FormatJerseyNumber(jerseyNumber: number | null | undefined, jerseyNumberPadding: number | null | undefined): string {

    let jerseyNumberText = '';

    if (jerseyNumber !== undefined && jerseyNumber !== null) {

        if (jerseyNumberPadding === undefined || jerseyNumberPadding === null) {
            jerseyNumberText =  jerseyNumber.toString();
        }
        else {
            jerseyNumberText = jerseyNumber.toString().padStart(jerseyNumberPadding, '0');
        }
    }


    return jerseyNumberText;
}